export const xSmallScreen = 414;
export const smallScreen = 768;
export const largeScreen = 979;
